var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M21.873 6.829a.5.5 0 0 1-.706.041L17.5 3.61V19a.5.5 0 1 1-1 0V3.61l-3.667 3.26a.5.5 0 0 1-.665-.747l4.494-3.994a.51.51 0 0 1 .677 0l4.494 3.994a.5.5 0 0 1 .041.706m-8.983 10.36a.5.5 0 0 0-.703-.078L8 20.461V5.001a.5.5 0 1 0-1 0v15.46l-4.187-3.35a.5.5 0 0 0-.625.78l4.994 3.996.02.015a.5.5 0 0 0 .617-.015l4.994-3.995a.5.5 0 0 0 .078-.703",
    clipRule: "evenodd"
  })));
});
const SvgSwing = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSwing);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yMS44NzMyIDYuODI4OEMyMS42ODk4IDcuMDM1MTkgMjEuMzczNyA3LjA1Mzc4IDIxLjE2NzMgNi44NzAzM0wxNy40OTk1IDMuNjEwMDRMMTcuNDk5NSAxOS4wMDA1QzE3LjQ5OTUgMTkuMjc2NyAxNy4yNzU2IDE5LjUwMDUgMTYuOTk5NSAxOS41MDA1QzE2LjcyMzQgMTkuNTAwNSAxNi40OTk1IDE5LjI3NjcgMTYuNDk5NSAxOS4wMDA1TDE2LjQ5OTUgMy42MTAwNEwxMi44MzE3IDYuODcwMzJDMTIuNjI1MyA3LjA1Mzc4IDEyLjMwOTMgNy4wMzUxOSAxMi4xMjU4IDYuODI4OEMxMS45NDIzIDYuNjIyNDEgMTEuOTYwOSA2LjMwNjM3IDEyLjE2NzMgNi4xMjI5MkwxNi42NjA3IDIuMTI4ODJDMTYuODUzOSAxLjk1NzA2IDE3LjE0NTEgMS45NTcwNiAxNy4zMzgzIDIuMTI4ODJMMjEuODMxNyA2LjEyMjkyQzIyLjAzODEgNi4zMDYzNyAyMi4wNTY3IDYuNjIyNDEgMjEuODczMiA2LjgyODhaTTEyLjg4OTkgMTcuMTg5MUMxMi43MTc0IDE2Ljk3MzUgMTIuNDAyOCAxNi45Mzg1IDEyLjE4NzEgMTcuMTExTDcuOTk5NDEgMjAuNDYxMkw3Ljk5OTQxIDUuMDAwOThDNy45OTk0MSA0LjcyNDgzIDcuNzc1NTYgNC41MDA5OCA3LjQ5OTQxIDQuNTAwOThDNy4yMjMyNyA0LjUwMDk4IDYuOTk5NDEgNC43MjQ4MyA2Ljk5OTQxIDUuMDAwOThMNi45OTk0MSAyMC40NjExTDIuODExODQgMTcuMTExQzIuNTk2MjEgMTYuOTM4NSAyLjI4MTU2IDE2Ljk3MzUgMi4xMDkwNiAxNy4xODkxQzEuOTM2NTUgMTcuNDA0NyAxLjk3MTUxIDE3LjcxOTQgMi4xODcxNCAxNy44OTE5TDcuMTgwOSAyMS44ODY5QzcuMTg3NDkgMjEuODkyMiA3LjE5NDE4IDIxLjg5NzMgNy4yMDA5NiAyMS45MDIyQzcuMjg0MjYgMjEuOTY0MiA3LjM4NzU0IDIyLjAwMSA3LjQ5OTQxIDIyLjAwMUM3LjYwOTE3IDIyLjAwMSA3LjcxMDY4IDIxLjk2NTYgNy43OTMxNSAyMS45MDU2QzcuODAxNiAyMS44OTk3IDcuODA5OTIgMjEuODkzNCA3LjgxODA5IDIxLjg4NjlMMTIuODExOCAxNy44OTE5QzEzLjAyNzUgMTcuNzE5NCAxMy4wNjI0IDE3LjQwNDcgMTIuODg5OSAxNy4xODkxWiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";